<template>
  <section id="admin-filter">
    <h4>Exchange Rate History filter</h4>
    <div class="form-group">
      <label for="ex-filter-from" class="form-label">Exchange Rate</label>
      <select class="form-control" id="ex-filter-from" v-model="entity.exchangeRate">
        <option v-for="(opt, i) in exchangeRates" :value="opt.id">{{ makeName(opt) }}</option>
      </select>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  export default {
    name: 'ExchangeRateHistoryFilter',
    mixins: [ FilterMixin ],
    data () {
      return {
        entity: {
          exchangeRate: ''
        }
      }
    },
    computed: {
      exchangeRates () {
        return this.$store.getters['systemOption/exRates']
      }
    },
    methods: {
      makeName ({ fromCurrency, toCurrency }) {
        let from = fromCurrency !== null ? fromCurrency.code : 'N/A'
        let to = toCurrency !== null ? toCurrency.code : 'N/A'
        return `${from} --> ${to}`
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// ExchangeRateHistoryFilter.vue?5fc30374